/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import Icon from "../../../components/Icon";
import { Navbar } from "../../../components/navbar";
import {
  faSearch,
  faCommentDots,
  faQrcode,
  faClose,
} from "@fortawesome/free-solid-svg-icons";
import qrLogo from "../../../assets/qrLogo.png";
import brandLogo from "../../../assets/parkingHeroLogo.png";
import filter from "../../../assets/icons/filter.png"
import "./styles.scss";
import ToggleButton from "../../../components/ToggleButton";
import Pagination from "../../../components/Pagination";
import { AuthService } from "../../../services/auth.service";
import { STATUS } from "../../../common/constant";
import { QRCodeCanvas } from "qrcode.react";
import { useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { UserManagement } from "../../../components/userManagement";
import { AdminMenuListComponent } from "../../../components/adminMenu"
// import { HeroStatMenuList } from "../../../components/heroStatMenuList";

type UserDetailsProp = {
  user_id: string
  hero_name: string
  email_id: string
  phone_number: string
  zip_code: number
  is_active: boolean
  last_logged_on: string
}

const LandingPage: React.FC = () => {
  const [userData, setUserData] = useState<Array<UserDetailsProp>>();
  const [userManagement, setUserManagement] = useState<boolean>(false)
  const [userId, setUserId] = useState<string>('')
  const [name, setName] = useState<string>('')
  const [filterData, setFilterData] = useState<boolean>(false);
  const anchorRef = useRef<any>(null);
  const [page, setPage] = useState<number>(1)
  const [limit] = useState<number>(5)
  const [count] = useState<number>(3)
  const [showQR, setShowQR] = useState<boolean>(false);
  const [sendMessageDialog, setSendMessageDialog] = useState<boolean>(false);
  const navigate = useNavigate()
  const authenticationService = new AuthService();
  const userDetails = async () => {
    const userResponse: any = await authenticationService.userManagement(page, limit);
    if (userResponse.status === STATUS.SUCCESS) {
      setUserData(userResponse.data)
      console.log(userData)
    }
  }

  const downloadImg = async () => {
    const input = document.getElementById('divToPrint') as HTMLElement;
    html2canvas(input)
      .then((canvas: { toDataURL: (arg0: string) => any; }) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'pt', 'letter', true);
        pdf.addImage(imgData, 'JPEG', 180, 10, 250, 550);
        pdf.save("download.pdf");
      });
  }

  useEffect(() => {
    userDetails()
  }, [])

  return (
    <>
      <div className="admin-landing-page" style={userManagement ? { display: "none" } : { overflow: 'hidden' }}>
        <Navbar noAds Admin={true} />
        <div className="admin-page-content" >
          <h1 className="heading">Welcome admin</h1>
          <div className="table-heading-and-search">
            <h1 className="heading">user management</h1>
            <div className="search-container">
              <p className="parking-missions">
                Number of Successful Parking Missions: 10{" "}
              </p>
              <div className="search-input">
                <input type="text" placeholder="Search Hero Names" />
                <Icon icon={faSearch} />
              </div>
            </div>
          </div>
          <div className="user-table">
            <table>
              <thead>
                <tr>
                  <th>Hero Name</th>
                  <th>Email id</th>
                  <th>QR Code</th>
                  <th>Phone</th>
                  <th>Zip Code</th>
                  <th>Last Logged On</th>
                  <th>Send Message</th>
                  <th>Block</th>
                  <th className="filter">Opt out of Sale <img src={filter} onClick={() => { setFilterData(true) }} ref={anchorRef} alt="" /></th>
                </tr>
              </thead>
              <tbody>
                {filterData && <AdminMenuListComponent show={filterData} setShow={setFilterData} anchorRef={anchorRef} />}
                {userData?.map((user: UserDetailsProp, index) => {
                  return (
                    <tr key={index} onClick={() => {
                      setUserId(user.user_id)
                      setName(user.hero_name)
                    }}>
                      <td onClick={() => { setUserManagement(true) }}>{user.hero_name}</td>
                      <td onClick={() => { setUserManagement(true) }}>{user.email_id}</td>
                      <td onClick={() => setShowQR(true)}>
                        <Icon icon={faQrcode} />
                      </td>
                      <td onClick={() => { setUserManagement(true) }}>{user.phone_number}</td>
                      <td onClick={() => { setUserManagement(true) }}>{user.zip_code}</td>
                      <td onClick={() => { setUserManagement(true) }}>{user.last_logged_on}</td>
                      <td onClick={() => setSendMessageDialog(true)}>
                        <Icon icon={faCommentDots} />
                      </td>
                      {/* <HeroStatMenuList show={true} setShow={setShow} position={"left top"} anchorRef={anchorRef} message={messages} /> */}
                      <td>
                        <ToggleButton value={user.is_active} />
                      </td>
                      <td className="switch-field">
                        <p>YES</p>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="buttons-and-pagination">
            <div className="buttons">
              <button className="btn">Export Message Log</button>
              <button className="btn" onClick={() => { navigate("/admin/offers") }}>Upload Offers PDF</button>
            </div>
            <div className="pagination-wrapper">
              <Pagination setPage={setPage} page={page} count={count} />
            </div>
          </div>
        </div>

        <div className={showQR ? "view-qr-code-dialog" : "hide-element"}>
          <div className="dialog">
            <div className="header">
              <h6>{name}</h6>
              <div className="closeIcon" onClick={() => setShowQR(false)}>
                <Icon icon={faClose} />
              </div>
            </div>
            <div className="qrcode">
              <QRCodeCanvas
                value={`http://localhost:3001/timeforAction/${userId}`}
                size={200}
                bgColor={"#ffffff"}
                fgColor={"#000000"}
                level={"H"}
                includeMargin={false}
                imageSettings={{
                  src: qrLogo,
                  height: 60,
                  width: 60,
                  excavate: true,
                }}
              />
            </div>
            <button onClick={() => { downloadImg() }}>Download</button>
          </div>
        </div>
        <div className={sendMessageDialog ? "send-message-dialog" : "hide-element"}>
          <div className="send-message">
            <div className="closeIcon" onClick={() => setSendMessageDialog(false)}>
              <Icon icon={faClose} />
            </div>
            <p>Enter the Message</p>
            <input type="text" />
            <div className="buttons">
              <button onClick={() => setSendMessageDialog(false)}>Cancel</button>
              <button onClick={() => setSendMessageDialog(false)}>Send</button>
            </div>
          </div>
        </div>
        <div className="ToPrint">
          <div className="Download" id="divToPrint" >
            <div>
              {/* <p>- QR Code Generation with ReactJS POC by Jayasin Prabhu C</p> */}
              <div className="text">
                <img className='logo' src={brandLogo} alt="" />
                <h1>SCAN ME!!!</h1>
                <p>To Notify Drivers that their Car is about</p>
                <p>to Get a parking ticket </p>
                <h1>QR Code</h1>
              </div>

              <div className="download-qr">
                <QRCodeCanvas
                  value={`http://localhost:3001/timeforAction/${userId}`}
                  size={330}
                  bgColor={"#ffffff"}
                  fgColor={"#000000"}
                  level={"H"}
                  includeMargin={false}
                  imageSettings={{
                    src: qrLogo,
                    height: 60,
                    width: 60,
                    excavate: true,
                  }}
                />
              </div>
            </div>
            <h1> Become A </h1>
            <h1> Parking Hero </h1>
          </div>
        </div>
      </div>
      {userManagement && <UserManagement userid={userId} username={name} />}
    </>
  );
};

export default LandingPage;
